// "Divine Wisdom of the Day" — a mix of genuine motivational quotes and Bobex nonsense, so the panel
// never turns into a corporate wellness widget. Rotates once per day (stable within a day) to give
// everyone — sales, call center, marketing, devs — a reason to open God Mode again tomorrow.
export interface Wisdom {
    text: string;
    author?: string;
}

const WISDOM: Wisdom[] = [
    // Genuinely motivational
    { text: "You don't have to be great to start, but you have to start to be great.", author: 'Zig Ziglar' },
    { text: 'Success is the sum of small efforts, repeated day in and day out.', author: 'Robert Collier' },
    { text: 'The secret of getting ahead is getting started.', author: 'Mark Twain' },
    { text: 'Quality is not an act, it is a habit.', author: 'Aristotle' },
    // Bobex nonsense
    { text: "If at first you don't succeed, check if you selected the correct country.", author: 'Ancient Bobex proverb' },
    { text: 'Every lead is a new hope.', author: 'Definitely not Yoda' },
    { text: 'The Backoffice does not judge. The Backoffice remembers.' },
    { text: "Today's impossible request is tomorrow's dropdown option." },
    { text: 'Behind every successful user is a suspicious amount of coffee.' },
    { text: 'May your leads be qualified and your meetings be short.' },
    { text: 'You are doing great. The database has no opinion.' },
    { text: 'A filter a day keeps the full-table scan away.', author: 'Ancient Bobex proverb' },
];

// Ordinal day of the local year. Built from UTC-normalised calendar components so each local calendar
// day maps to a distinct integer: subtracting elapsed *wall-clock* ms would drift a day after a DST
// transition (a spring-forward day is only 23h), leaving the quote a day behind for the rest of the year.
const dayOfYear = (): number => {
    const now = new Date();
    const startUTC = Date.UTC(now.getFullYear(), 0, 0);
    const todayUTC = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.floor((todayUTC - startUTC) / 86_400_000);
};

export function getDivineWisdomOfTheDay(): Wisdom {
    return WISDOM[dayOfYear() % WISDOM.length];
}
